import script from "./boardHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./boardHeader.vue?vue&type=script&setup=true&lang=js"

import "./boardHeader.vue?vue&type=style&index=0&id=9e6e5c6c&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e6e5c6c"]])

export default __exports__